import { render, staticRenderFns } from "./LocationServiceAddress.vue?vue&type=template&id=45938743&scoped=true"
import script from "./LocationServiceAddress.vue?vue&type=script&lang=js"
export * from "./LocationServiceAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45938743",
  null
  
)

export default component.exports